import { render, staticRenderFns } from "./ViewModeToggle.vue?vue&type=template&id=6a474d26"
import script from "./ViewModeToggle.vue?vue&type=script&lang=ts"
export * from "./ViewModeToggle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports